import React, { useEffect } from "react";

import googleCalendarIcon from "../../assets/img/integrations/google-calendar.svg";
import gustoIcon from "../../assets/img/integrations/gusto.svg";
import outlookCalendarIcon from "../../assets/img/integrations/outlook-calendar.svg";
// Import existing integration icons
import xeroIcon from "../../assets/img/integrations/xero.svg";
import {
  CommonText,
  ContainerNew,
  PageTitle,
} from "../../styledComponents/common";
import {
  CardIcon,
  ConnectButton,
  IntegrationCard,
  IntegrationCardContainer,
  UpcomingBadge,
} from "../../styledComponents/integrations";
import { AuthHandler } from "./integrationHandler/authHandler/authHandlerService";

// Update integration data to use local assets and add hidden property
const integrationsData = [
  {
    name: "Gusto",
    icon: gustoIcon,
    path: "/user/integrations/gusto/setup",
    upcoming: false,
    disabled: false,
    hidden: false,
  },
  {
    name: "Xero",
    icon: xeroIcon,
    path: "/user/integrations/xero/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  {
    name: "Google Calendar",
    icon: googleCalendarIcon,
    path: "/user/integrations/google-calendar/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  {
    name: "Outlook Calendar",
    icon: outlookCalendarIcon,
    path: "/user/integrations/outlook-calendar/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  // Other integrations hidden by default
  // {
  //   name: "HighLevel",
  //   icon: GoHighLevel,
  //   path: "/user/ghl-settings/",
  //   upcoming: true,
  //   disabled: false,
  //   hidden: true,
  // },
  // {
  //   name: "ClickUp",
  //   icon: clickupIcon,
  //   path: "/user/integrations/clickup/setup",
  //   upcoming: true,
  //   disabled: true,
  //   hidden: true,
  // },
  // {
  //   name: "Trello Power-Up",
  //   icon: trelloIcon,
  //   path: "https://trello.com/power-ups/615d5b18dd889573e477dcdc/trello-time-tracking-by-apploye",
  //   upcoming: false,
  //   disabled: false,
  //   isExternal: true,
  //   hidden: true,
  // },
  // {
  //   name: "Asana",
  //   icon: asanaIcon,
  //   path: "/user/integrations/asana/setup",
  //   upcoming: false,
  //   disabled: false,
  //   hidden: true,
  // },
  // {
  //   name: "Slack",
  //   icon: slackIcon,
  //   path: "/user/integrations/slack/setup",
  //   upcoming: false,
  //   disabled: false,
  //   hidden: true,
  // },
  // {
  //   name: "Zapier",
  //   icon: zapierIcon,
  //   path: "/user/integrations/zapier/setup",
  //   upcoming: false,
  //   disabled: false,
  //   hidden: true,
  // },
  // {
  //   name: "Jira Software",
  //   icon: jiraIcon,
  //   path: "/user/integrations/jira/setup",
  //   upcoming: false,
  //   disabled: false,
  //   hidden: true,
  // },
];

const handleAuthFlow = (stepsData, otherData) => {
  const authHandler = new AuthHandler(stepsData, otherData);

  authHandler.init();
  // authHandler.run();
};

// Reusable Integration Card Component matching Figma design
const SingleIntegrationCard = props => {
  const {
    integration,
    history,
    selectedOrganization,
    connectIntegration,
    handleViewDetails,
    openOauthPopup,
  } = props;

  // Generic click handler: if accessible, navigate to path; else open OAuth popup
  const handleClick = () => {
    if (integration.disabled) return;

    // If accessible, navigate to setup path
    if (integration.isAccessible && integration.path) {
      history.push(integration.path);
      return;
    }

    // Not accessible -> open OAuth popup with provider name
    const providerName = (integration?.name || "").toLowerCase();
    if (openOauthPopup) {
      openOauthPopup(providerName);
    }
  };

  return (
    <IntegrationCard>
      {integration.upcoming && <UpcomingBadge>Upcoming</UpcomingBadge>}
      <CardIcon src={integration.icon} alt={`${integration.name}Icon`} />
      <CommonText
        fontWeight="700"
        margin="20px 0 0 0"
        fontSize="16px"
      >
        {integration.name}
      </CommonText>
      <ConnectButton
        disabled={integration.disabled}
        onClick={handleClick}
      >
        {integration.isAccessible ? "Open" : "Configure"}
      </ConnectButton>
    </IntegrationCard>
  );
};

// const AllIntegrations = props => {
//   const { history, integrations, enabledIntegrations, selectedOrganization } =
//     props;

//   const connectIntegration = integration => {
//     // const { route } = integration;
//     // if (route) {
//     //   if (route.isLink) {
//     //     window.open(route.pathname, "_blank");
//     //   }
//     // } else {
//     if (
//       selectedOrganization &&
//       selectedOrganization.id &&
//       integration.id &&
//       integration.frontend_steps &&
//       integration.frontend_steps.length > 0
//     ) {
//       handleAuthFlow(integration.frontend_steps, {
//         organization_id: selectedOrganization.id,
//         integration_id: integration.id,
//       });
//     }
//     // }
//   };

//   const handleViewDetails = integrationId => {
//     if (enabledIntegrations && enabledIntegrations.length > 0) {
//       enabledIntegrations.some(item => {
//         if (item.integration_id === integrationId) {
//           history.push({
//             pathname: `/user/integrations/${item.id}/details`,
//             state: {
//               enabledIntegration: {
//                 ...item,
//               },
//             },
//           });
//           return true;
//         }
//         return false;
//       });
//     }
//   };

//   return (
//     <AllIntegrationsContainer>
//       <AllIntegrationsDiv>
//         {integrations &&
//           integrations.map((integration, index) => (
//             <React.Fragment key={index}>
//               <SingleIntegrationCard
//                 integration={integration}
//                 history={history}
//                 selectedOrganization={selectedOrganization}
//                 handleViewDetails={handleViewDetails}
//                 connectIntegration={connectIntegration}
//               />
//             </React.Fragment>
//           ))}
//       </AllIntegrationsDiv>
//       {/* <CommonColorButton padding="13px 25px">
//           All Integrations
//         </CommonColorButton> */}
//     </AllIntegrationsContainer>
//   );
// };

const IntegrationsNew = props => {
  const {
    history,
    getAllIntegrationsList,
    allIntegrationsList,
    getEnabledIntegrationsList,
    enabledIntegrationsList,
    isLoading,
    selectedOrganization,
  } = props;

  // Determine access: org-level integrations are open for everyone; user-level are open only to the owning user
  const currentUserId = localStorage.getItem("user_id");

  // const connectIntegration = integration => {
  //   if (
  //     selectedOrganization &&
  //     selectedOrganization.id &&
  //     integration.id &&
  //     integration.frontend_steps &&
  //     integration.frontend_steps.length > 0
  //   ) {
  //     handleAuthFlow(integration.frontend_steps, {
  //       organization_id: selectedOrganization.id,
  //       integration_id: integration.id,
  //     });
  //     return;
  //   }

  //   // Fallback for integrations that require a direct OAuth popup (legacy Gusto flow)
  //   if ((integration?.name || "").toLowerCase() === "gusto") {
  //     openOauthPopup && openOauthPopup();
  //   }
  // };

  useEffect(() => {
    if (selectedOrganization?.id) {
      const payload = {
        organization_id: selectedOrganization.id,
      };
      getAllIntegrationsList(payload);
      // getEnabledIntegrationsList(payload);
    }
  }, [selectedOrganization]);

  // Generic OAuth popup handler for any provider
  const openOauthPopup = (provider) => {
    const w = 715;
    const h = 1070;
    const y = (screen.height - h) / 2;
    const x = (screen.width - w) / 2;

    const providerName = (provider || "").toLowerCase();
    const popup = window.open(
      `${process.env.REACT_APP_API_URL}/api/authentication/${providerName}/?organization_id=${selectedOrganization.id}`,
      "_blank",
      `width=${w},height=${h},left=${x},top=${y}`,
    );

    if (!popup) {
      console.warn(`⚠️ Popup was blocked for ${providerName}.`);
      return;
    }

    const poll = setInterval(() => {
      if (popup.closed) {
        console.log(`✅ ${provider} authentication successful and popup closed.`);
        clearInterval(poll);
        setTimeout(() => {
          // Refresh to show "Open" button
          window.location.reload();
        }, 2250);
      }
    }, 1000);

    // Optional: timeout after 30s
    setTimeout(() => {
      clearInterval(poll);
      console.warn(`⏰ Polling timed out for ${providerName}.`);
    }, 30000);
  };

  const handleViewDetails = integrationId => {
    if (enabledIntegrationsList && enabledIntegrationsList.length > 0) {
      enabledIntegrationsList.some(item => {
        if (item.integration_id === integrationId) {
          history.push({
            pathname: `/user/integrations/${item.id}/details`,
            state: {
              enabledIntegration: {
                ...item,
              },
            },
          });
          return true;
        }
        return false;
      });
    }
  };

  const organizationLevelIntegrationNames = new Set(
    (allIntegrationsList || [])
      .filter(integration => integration?.is_organization_level)
      .map(integration => (integration?.name || "").toLowerCase()),
  );

  const userLevelIntegrationNamesForCurrentUser = new Set(
    (allIntegrationsList || [])
      .filter(
        integration => !integration?.is_organization_level && integration?.user,
      )
      .filter(integration => String(integration.user) === String(currentUserId))
      .map(integration => (integration?.name || "").toLowerCase()),
  );

  return (
    <div className="content">
      <ContainerNew>
        <PageTitle>Integrations</PageTitle>
        <IntegrationCardContainer>
          {integrationsData.map((integration, index) => {
            const nameKey = (integration?.name || "").toLowerCase();
            const isOrganizationLevel =
              organizationLevelIntegrationNames.has(nameKey);
            const isAccessible =
              isOrganizationLevel ||
              userLevelIntegrationNamesForCurrentUser.has(nameKey);

            return (
              <SingleIntegrationCard
                key={index}
                integration={{
                  ...integration,
                  isOrganizationLevel,
                  isAccessible,
                }}
                history={history}
                selectedOrganization={selectedOrganization}
                // handleViewDetails={handleViewDetails}
                // connectIntegration={connectIntegration}
                openOauthPopup={openOauthPopup}
              />
            );
          })}
        </IntegrationCardContainer>
      </ContainerNew>
    </div>
  );
};

export default IntegrationsNew;
